import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Health_Innovation from "./health-innovation/Health_Innovation";
import Gymify_Animation from "./gymify-animation/Gymify_Animation";
import Member_Banner from "./member-banner/Member_Banner";
import Why_Choose_Us from "./why-choose-us/Why_Choose_Us";
import Take_Your_Goal from "./take-your-goal/Take_Your_Goal";
import Contact_Us from "./contact-us/Contact_Us";
import Download_Now from "./download-now/Download_Now";

function Home() {
  return (
    <>
      <Banner />
      <Health_Innovation />
      <Gymify_Animation />
      <Member_Banner />
      <Why_Choose_Us />
      <Take_Your_Goal />
      <Contact_Us />
      <Download_Now />
    </>
  );
}

export default Home;
